export const accommodationSkiBlock = {
  SKI_BLOCK_DESCRIPTION_TOGGLED: 'accommodationSkiBlock.description'
}
